export default __webpack_public_path__ + "static/media/200629 Luci -- Watercolor.e6f1354c.png";